import React from 'react';
import FadeIn from 'react-fade-in/lib/FadeIn';
import PropTypes from 'prop-types';
/* react-bootstrap */
import { Media, ButtonGroup, DropdownButton, Dropdown, Card, ProgressBar } from 'react-bootstrap';
/* --------------- */
import './styles.scss';
/* helpers */
import { formattedSecondsTime } from '../../utils/dateFnsUtils.js'
import { seasonsCounter } from '../../utils/seasonUtils'
/* hook */
import { useDidMount } from './hooks.js'
import ContentCard from '../ContentCard';
import WithErrorBoundary from '../../HOCs/WithErrorBoundary';
import Skeleton from './components/Skeleton';
import classNames from '../../utils/classnameUtils';
import { secondsToHours } from 'date-fns';

function ContentEpisodes({
    translationTexts,
    content,
    disabledEpisodes = false,
    onClickContentSelected,
    contentNoImageProps,
    contentCardProps = {},
    imageMode = 'THUMB',
    textMode = 'none',
    isLoading = false,
    countItem = 3,
    currentSeason = 0
}) {

    const { result, seasonCount, seasonIndex, setSeasonIndex } = useDidMount(content, isLoading, countItem, currentSeason);

    const titleOfButtons = (
        <div className="tbxContentEpisodes__buttonsTitle">
            <p className="tbxContentEpisodes__buttonsSeason">{`${translationTexts.season} ${seasonIndex}`}</p><i className="tbxContentEpisodes__downIcon bi bi-chevron-down" />
        </div>
    )

    const handlerHours = (secondsTime) => !!secondsToHours(secondsTime) ? ` ${secondsToHours(secondsTime)} hs.` : '';

    return (
        <div className="tbxContentEpisodes__container">
            <div className="tbxContentEpisodes__header">
                <FadeIn delay={150}><h2 className="tbxContentEpisodes__header__title">{translationTexts.episodes}</h2></FadeIn>
                {!isLoading &&
                    <React.Fragment>
                        {(seasonsCounter(seasonCount) > 1) ?
                            <DropdownButton className="tbxContentEpisodes__header_seasonSelector" as={ButtonGroup} title={titleOfButtons} bsPrefix="" >
                                <FadeIn>
                                    {Object.keys(seasonCount)?.map((e) =>
                                        <Dropdown.Item className={e == seasonIndex ? 'active' : ''} onClick={() => setSeasonIndex(Number(e))} key={e}>{translationTexts.season} {e}</Dropdown.Item>
                                    )}
                                </FadeIn>
                            </DropdownButton>
                            :
                            <h5 className="tbxContentEpisodes__header_onlySeason">{translationTexts.season} {seasonIndex}</h5>
                        }
                    </React.Fragment>
                }
            </div>
            <div className="tbxContentEpisodes_list">
                {result?.map((r,index) =>
                    (seasonIndex === r?.season || isLoading) && (
                        <Media className={classNames("tbxContentEpisodes_list__item","tbxContentEpisodes_list__item__disabled__"+disabledEpisodes)} onClick={() => !isLoading && !disabledEpisodes && onClickContentSelected(r?.id)} as="div" key={index}>
                                <ContentCard
                                    {...contentCardProps}
                                    content={r}
                                    contentNoImageProps={contentNoImageProps}
                                    classNameProps="tbxContentEpisodes_card tbxContentEpisodes_list__item__image"
                                    imageMode={imageMode}
                                    textMode={textMode}
                                    isLoading={isLoading}
                                />    
                            {isLoading ? <FadeIn delay={150}><Skeleton {...contentNoImageProps} /></FadeIn> :
                                <div className="tbxContentEpisodes_list__item__info">
                                    <FadeIn delay={150}>
                                        <p className="tbxContentEpisodes_list__item__info__title">{r?.title}</p>
                                        <p className="tbxContentEpisodes_list__item__info__metadata">{translationTexts.season[0]}{r?.season} | {translationTexts.episode[0]}{r?.episode} -{handlerHours(r?.duration)} {formattedSecondsTime(r?.duration, "mm")} min. </p>
                                        <p className="tbxContentEpisodes_list__item__info__description">
                                            {r?.description}
                                        </p>
                                    </FadeIn>
                                </div>
                            }
                        </Media>))}
            </div>
        </div>
    );
}


ContentEpisodes.propTypes = {
    content: PropTypes.shape({
        result: PropTypes.array,
    }),
    disabledEpisodes: PropTypes.bool,
    onClickContentSelected: PropTypes.func,
    contentCardProps: PropTypes.object,
    textMode: PropTypes.string,
    imageMode: PropTypes.string,
    contentNoImageProps: PropTypes.object,
    isLoading: PropTypes.bool,
    countItem: PropTypes.number,
    currentSeason: PropTypes.number
}


export default WithErrorBoundary(React.memo(ContentEpisodes));


